var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Offer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-offer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7077",
    "data-name": "Rectangle 7077",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(-23 -17.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M61.545,28.641A6.839,6.839,0,0,0,59.1,26.3a1.673,1.673,0,0,0-.77-.2c-.672,0-1.185.489-1.381,1.32a.838.838,0,0,0,.318.965,3.443,3.443,0,0,0,.819.415,5.681,5.681,0,0,0,1.711.232c.513,0,1.026-.049,1.6-.1a.171.171,0,0,0,.147-.11A.133.133,0,0,0,61.545,28.641Zm-1.735.012a5.437,5.437,0,0,1-1.613-.208,3.164,3.164,0,0,1-.733-.367c-.061-.037-.257-.159-.159-.574.159-.66.538-1.039,1.026-1.039a1.292,1.292,0,0,1,.6.159,6.27,6.27,0,0,1,2.114,1.967C60.616,28.629,60.213,28.654,59.81,28.654Z",
    transform: "translate(-27.139 -6.145)",
    fill: "#02466a",
    stroke: "#02466a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M107.243,28.683c.024.012.061,0,.073.012a.445.445,0,0,0,.183.024h.037c.171,0,.342.024.525.024s.354.012.525.012c.379,0,.684,0,.953-.024a7.7,7.7,0,0,0,1.5-.318.93.93,0,0,0,.672-.941,1.6,1.6,0,0,0-.464-1.136,1.309,1.309,0,0,0-1.417-.354,7,7,0,0,0-2.7,2.431.172.172,0,0,0-.024.171A.217.217,0,0,0,107.243,28.683Zm2.749-2.37a.917.917,0,0,1,1,.281,1.288,1.288,0,0,1,.367.868.567.567,0,0,1-.415.6,6.527,6.527,0,0,1-1.43.305c-.269.024-.55.037-.929.037h-.977A6.221,6.221,0,0,1,109.992,26.313Z",
    transform: "translate(-71.187 -5.967)",
    fill: "#02466a",
    stroke: "#02466a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M42.2,23.12H40.625c.049,0,.086-.086.122-.122.073-.073.159-.147.232-.208a1.59,1.59,0,0,0,.55-1.393,2.555,2.555,0,0,0-2.346-2.3,1.185,1.185,0,0,0-.208.012,4.384,4.384,0,0,0-2.688,1.5c-.318.33-.6.672-.9,1.039-.073.086-.159.183-.232.281a.329.329,0,0,0-.086-.1c-.134-.171-.281-.354-.428-.538a6.334,6.334,0,0,0-2.578-2.016,2.619,2.619,0,0,0-.892-.171,2.409,2.409,0,0,0-2.236,1.808,1.736,1.736,0,0,0,.733,2.2H28.04a1.949,1.949,0,0,0-2.04,1.8v11.95a2.133,2.133,0,0,0,2.04,2.016H42.2a1.889,1.889,0,0,0,1.759-2.016V24.916A1.717,1.717,0,0,0,42.2,23.12Zm1.393,1.8v2.725H35.9V23.486h6.3A1.344,1.344,0,0,1,43.594,24.916ZM29.873,22.8a1.35,1.35,0,0,1-.586-1.784,2.042,2.042,0,0,1,1.882-1.552,2.135,2.135,0,0,1,.758.147,5.992,5.992,0,0,1,2.431,1.918c.147.171.281.354.415.525.073.1.147.183.22.281a.169.169,0,0,0,.134.073.225.225,0,0,0,.147-.061l.379-.452c.305-.354.586-.7.892-1.026a4.073,4.073,0,0,1,2.468-1.393c.049,0,.11-.012.159-.012a2.188,2.188,0,0,1,1.979,1.967,1.24,1.24,0,0,1-.415,1.075c-.086.061-.159.147-.244.22-.171.147-.342.269-.5.391H30.374C30.166,23,29.971,22.863,29.873,22.8Zm-3.507,2.114a1.584,1.584,0,0,1,1.674-1.43h6.146v4.154h-7.82Zm0,11.95V29.351h7.82v9.164H28.04A1.777,1.777,0,0,1,26.367,36.865Zm9.164-7.71v9.359h-.977V29.156c0-.1-.024-.171-.122-.171H26.367v-.977h8.064c.1,0,.122-.1.122-.2V23.486h.977v4.325c0,.1.147.2.244.2h7.82v.977h-7.82C35.677,28.985,35.53,29.046,35.53,29.156Zm8.064,7.71A1.542,1.542,0,0,1,42.2,38.515H35.9V29.351h7.7Z",
    fill: "#02466a",
    stroke: "#02466a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Offer);
export default __webpack_public_path__ + "static/media/icon-24-offer.481ade091de10935a7106b1a6fc718cc.svg";
export { ForwardRef as ReactComponent };